
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrdineSlim } from '@/models';
import ItemListOrdine from "./ItemListOrdine.vue";

@Component({
    components: { ItemListOrdine }
})
export default class OrdiniList extends Vue {
    @Prop() private ordini!: OrdineSlim[];    
}
